"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallToActionSection = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("../../../../shared/core");
var copy_1 = require("../../copy");
var InlineBlock = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var CallToActionSection = function (_a) {
    var actions = _a.actions, fuelType = _a.fuelType, isSmart = _a.isSmart, supplyIndex = _a.supplyIndex;
    var ButtonGroup = (0, core_1.useComponents)().ButtonGroup;
    var availableActions = actions.filter(function (action) { return action != null; });
    if (availableActions.length === 0) {
        return null;
    }
    return (react_1.default.createElement(ButtonGroup, { "data-testid": "meter-reading-summary-card_ctas" }, availableActions.map(function (action) { return (react_1.default.createElement(CTA, { fuelType: fuelType, isSmart: isSmart, ctaType: action, supplyIndex: supplyIndex, key: action })); })));
};
exports.CallToActionSection = CallToActionSection;
function CTA(_a) {
    var ctaType = _a.ctaType, fuelType = _a.fuelType, isSmart = _a.isSmart, supplyIndex = _a.supplyIndex;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    if (fuelType) {
        if (ctaType === 'SubmitReading') {
            return (react_1.default.createElement("div", { "data-testid": "summary-submit-reading" },
                react_1.default.createElement(Copy, { copyKey: "summarySubmitReading", props: { fuelType: fuelType, isSmart: isSmart, supplyIndex: supplyIndex }, values: { fuelType: fuelType ? fuelType : '' } })));
        }
        if (ctaType === 'ViewHistory') {
            return (react_1.default.createElement("div", { "data-testid": "summary-view-history" },
                react_1.default.createElement(Copy, { copyKey: "summaryViewHistory", props: { fuelType: fuelType, supplyIndex: supplyIndex } })));
        }
    }
    if (ctaType === 'SubmitOMRReading') {
        return (react_1.default.createElement(InlineBlock, { "data-testid": "send-in-omr-reading" },
            react_1.default.createElement(Copy, { copyKey: "sendInOMRReading" }),
            react_1.default.createElement(Copy, { copyKey: "summarySubmitReading", props: { fuelType: fuelType, isSmart: isSmart, supplyIndex: supplyIndex }, values: { fuelType: fuelType ? fuelType : '' } })));
    }
    if (ctaType === 'SubmitOMRReadingAgain') {
        return (react_1.default.createElement(InlineBlock, { "data-testid": "send-in-omr-reading-again" },
            react_1.default.createElement(Copy, { copyKey: "sendInOMRReadingAgain", values: { fuelType: fuelType } }),
            react_1.default.createElement(Copy, { copyKey: "summarySubmitReading", props: { fuelType: fuelType, isSmart: isSmart, supplyIndex: supplyIndex }, values: { fuelType: fuelType ? fuelType : '' } })));
    }
    if (ctaType === 'OnboardingNotInOMRWindow') {
        return (react_1.default.createElement(InlineBlock, { "data-testid": "wait-for-omr-window-to-start" },
            react_1.default.createElement(Copy, { copyKey: "waitForOMRWindowToStart" })));
    }
    return null;
}
var templateObject_1;
